import FilterDropdown from "./FilterDropdown";
import React from "react";
import {isDiscounted} from "../models/constants";

export default function FilterList({specificationFilters, attributeFilters, onSpecificationFilterChanged, onAttributeFilterChanged,}) {
    return <div className="border-top mb-npixel">
        {specificationFilters
            .map(filter => Object.assign(filter, {onChanged: onSpecificationFilterChanged}))
            .concat(attributeFilters.map(filter => Object.assign(filter, {onChanged: onAttributeFilterChanged})))
            .sort((a, b) => a.OrderBy - b.OrderBy)
            .map((filter) => <FilterDropdown filter={filter}
                                             key={filter.Id}
                                             isDiscounted={isDiscounted(filter.Id)}
                                             onChanged={filter.onChanged}/>)
        }
    </div>
}